const chevronUp = `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.21967 10.5303C2.92678 10.2374 2.92678 9.76256 3.21967 9.46967L7.46967 5.21967C7.76256 4.92678 8.23744 4.92678 8.53033 5.21967L12.7803 9.46967C13.0732 9.76256 13.0732 10.2374 12.7803 10.5303C12.4874 10.8232 12.0126 10.8232 11.7197 10.5303L8 6.81066L4.28033 10.5303C3.98744 10.8232 3.51256 10.8232 3.21967 10.5303Z"/></svg>`;
export {
  chevronUp as default
};
//# sourceMappingURL=chevronUp.mjs.map
